const defaultBrand = {
  companyName: '',
  systemName: 'HRM系统',
  pageTitle: 'HRM系统',
  loginTitle: 'HRM系统',
  sidebarTitle: 'HRM系统',
  logoUrl: '/logo.png',
  faviconUrl: '/favicon.ico',
  themeColor: '#012372'
}

function pickText (...values) {
  for (const value of values) {
    const text = String(value || '').trim()
    if (text) return text
  }
  return ''
}

function normalizeRuntimeBrand (config = {}) {
  const theme = config.theme || {}
  const loginPage = config.loginPage || {}
  const systemPage = config.systemPage || {}
  const companyName = pickText(config.companyName, defaultBrand.companyName)
  const systemName = pickText(config.systemName, systemPage.systemName, defaultBrand.systemName)
  const normalized = {
    ...config,
    companyName,
    systemName,
    pageTitle: pickText(config.pageTitle, config.appName, config.systemTitle, systemPage.systemName, `${companyName}HRM系统`),
    loginTitle: pickText(config.loginTitle, loginPage.title, config.pageTitle, `${companyName}HRM系统`),
    loginSubtitle: pickText(config.loginSubtitle, loginPage.subtitle, config.appDesc, '组织、人事、考勤、薪酬与文件管理统一入口'),
    sidebarTitle: pickText(config.sidebarTitle, config.logoTitle, `${companyName}HRM系统`),
    logoUrl: pickText(config.logoUrl, defaultBrand.logoUrl),
    faviconUrl: pickText(config.faviconUrl, defaultBrand.faviconUrl),
    themeColor: pickText(config.themeColor, config.primaryColor, theme.primaryColor, defaultBrand.themeColor),
    primaryColor: pickText(config.primaryColor, theme.primaryColor, config.themeColor, defaultBrand.themeColor),
    secondaryColor: pickText(config.secondaryColor, theme.secondaryColor),
    sidebarColor: pickText(config.sidebarColor, theme.sidebarColor),
    sidebarTextColor: pickText(config.sidebarTextColor, theme.sidebarTextColor),
    sidebarActiveColor: pickText(config.sidebarActiveColor, theme.sidebarActiveColor, config.primaryColor, theme.primaryColor),
    buttonColor: pickText(config.buttonColor, theme.buttonColor, config.primaryColor, theme.primaryColor),
    linkColor: pickText(config.linkColor, theme.linkColor, config.primaryColor, theme.primaryColor),
    loginBackgroundColor: pickText(config.loginBackgroundColor, loginPage.backgroundColor),
    loginGradientStart: pickText(config.loginGradientStart, loginPage.gradientStart),
    loginGradientEnd: pickText(config.loginGradientEnd, loginPage.gradientEnd),
    loginTitleColor: pickText(config.loginTitleColor, loginPage.titleColor),
    loginSubtitleColor: pickText(config.loginSubtitleColor, loginPage.subtitleColor),
    loginCopyrightColor: pickText(config.loginCopyrightColor, loginPage.copyrightColor),
    welcomeText: pickText(config.welcomeText, config.welcomeTitle, systemPage.welcomeText)
  }
  if (normalized.systemCode && String(normalized.systemCode).toUpperCase() === 'HRM') {
    normalized.systemName = 'HRM系统'
    normalized.pageTitle = pickText(config.pageTitle, config.appName, config.systemTitle, `${companyName}HRM系统`)
    normalized.loginTitle = pickText(config.loginTitle, loginPage.title, normalized.pageTitle)
    normalized.sidebarTitle = pickText(config.sidebarTitle, config.logoTitle, `${companyName}HRM系统`)
  }
  return normalized
}

const runtimeBrand = Object.assign(
  {},
  normalizeRuntimeBrand(window.HRM_CONFIG || {}),
  normalizeRuntimeBrand(window.HRM_CUSTOMER_CONFIG || {})
)
const brand = Object.assign({}, defaultBrand, runtimeBrand)

function normalizeHex (value) {
  const raw = String(value || '').trim().replace('#', '')
  if (raw.length === 3) {
    return raw.split('').map(char => char + char).join('')
  }
  return raw.length === 6 ? raw : '012372'
}

function hexToRgb (hex) {
  const normalized = normalizeHex(hex)
  return {
    r: parseInt(normalized.slice(0, 2), 16),
    g: parseInt(normalized.slice(2, 4), 16),
    b: parseInt(normalized.slice(4, 6), 16)
  }
}

function setThemeVariables () {
  const root = document.documentElement
  const primary = brand.themeColor || defaultBrand.themeColor
  const primaryRgb = hexToRgb(primary)

  root.style.setProperty('--brand-primary', primary)
  root.style.setProperty('--brand-primary-rgb', `${primaryRgb.r}, ${primaryRgb.g}, ${primaryRgb.b}`)
  root.style.setProperty('--ui-accent', brand.buttonColor || brand.primaryColor || '#426d9f')
  root.style.setProperty('--ui-accent-deep', brand.secondaryColor || '#1d3557')
  root.style.setProperty('--ui-accent-soft', '#e7eef8')
  root.style.setProperty('--ui-ink', '#243446')
  root.style.setProperty('--ui-muted', '#6d7b90')
  root.style.setProperty('--ui-border', 'rgba(36, 52, 70, 0.12)')
  root.style.setProperty('--ui-panel', 'rgba(255, 255, 255, 0.86)')
  root.style.setProperty('--ui-panel-strong', 'rgba(255, 255, 255, 0.94)')
  root.style.setProperty('--ui-page-bg', '#e9edf3')
  if (brand.sidebarColor) root.style.setProperty('--hrm-sidebar-bg', brand.sidebarColor)
  if (brand.sidebarTextColor) root.style.setProperty('--hrm-sidebar-text', brand.sidebarTextColor)
  if (brand.sidebarActiveColor) root.style.setProperty('--hrm-sidebar-active', brand.sidebarActiveColor)
}

export function applyBrandToDocument () {
  document.title = brand.pageTitle
  setThemeVariables()

  const favicon = document.querySelector('link[rel="icon"]') || document.createElement('link')
  favicon.rel = 'icon'
  favicon.href = brand.faviconUrl
  document.head.appendChild(favicon)
}

export default brand
